module.exports = __webpack_public_path__ + "749f968f44bc3c9525f8c57ee5f34d44.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flask-blue-s.png
// module id = 2636
// module chunks = 0